function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.996778 32.191C4.08872 42.4936 13.6533 50 24.9731 50C38.7948 50 50 38.8069 50 25C50 11.1929 38.7948 0 24.9731 0C11.7098 0 0.857143 10.3067 0 23.3391C1.61957 26.0558 2.25156 27.7361 0.997014 32.191H0.996778Z",
  fill: "url(#paint4_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.7795 19.5729C23.7795 19.6143 23.7795 19.6556 23.7817 19.6945L17.6384 28.4399C16.6433 28.3956 15.6447 28.5667 14.6978 28.9489C14.2804 29.1157 13.8893 29.3206 13.5223 29.5571L0.0327779 24.115C0.0328835 24.115 -0.279362 29.1474 1.02145 32.898L10.5578 36.7542C11.0366 38.8512 12.5046 40.6906 14.6703 41.5754C18.2136 43.0262 22.2991 41.3727 23.773 37.8988C24.1566 36.9907 24.3355 36.0382 24.3096 35.0879L33.0995 28.932C33.1706 28.9341 33.2439 28.9362 33.315 28.9362C38.5752 28.9362 42.8505 24.7337 42.8505 19.5729C42.8505 14.4116 38.5752 10.2129 33.315 10.2129C28.057 10.2129 23.7795 14.4116 23.7795 19.5729ZM22.3055 37.2948C21.1647 39.9789 18.0173 41.2523 15.2814 40.1352C14.0193 39.6199 13.0664 38.6759 12.5166 37.5503L15.6208 38.8111C17.6384 39.6347 19.9532 38.697 20.7919 36.7204C21.6332 34.7416 20.6788 32.4693 18.6622 31.6457L15.4534 30.3427C16.6916 29.8823 18.0992 29.8654 19.4143 30.4018C20.7402 30.9424 21.769 31.9603 22.3142 33.2612C22.8594 34.5621 22.8572 35.9981 22.3055 37.2948ZM33.315 25.8107C29.8133 25.8107 26.9623 23.0126 26.9623 19.5729C26.9623 16.1359 29.8133 13.3369 33.315 13.3369C36.8189 13.3369 39.6699 16.1359 39.6699 19.5729C39.6699 23.0126 36.8189 25.8107 33.315 25.8107ZM28.5548 19.5634C28.5548 16.9758 30.6925 14.877 33.3258 14.877C35.9612 14.877 38.0989 16.9758 38.0989 19.5634C38.0989 22.1512 35.9612 24.248 33.3258 24.248C30.6925 24.248 28.5548 22.1512 28.5548 19.5634Z",
  fill: "#F2F2F2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 25,
  y1: 0,
  x2: 25,
  y2: 50,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#111D2E"
}), React.createElement("stop", {
  offset: 0.21248,
  stopColor: "#051839"
}), React.createElement("stop", {
  offset: 0.40695,
  stopColor: "#0A1B48"
}), React.createElement("stop", {
  offset: 0.5811,
  stopColor: "#132E62"
}), React.createElement("stop", {
  offset: 0.7376,
  stopColor: "#144B7E"
}), React.createElement("stop", {
  offset: 0.87279,
  stopColor: "#136497"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1387B8"
})));

var SvgSourceSteam = function SvgSourceSteam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceSteam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_steam.ba9a3f35.svg";
export { ForwardRef as ReactComponent };